export class DonationsListItemState {
	confirmDelete: boolean;

	constructor() {
		this.confirmDelete = false;
	}
}